import React from 'react';
import { Shield, Scale, FileText, AlertCircle } from 'lucide-react';

export default function TermsAndConditions() {
  const sections = [
    { id: 'acceptance', title: '1. Acceptance of Terms', content: 'By accessing MbogiCapital, you agree to be bound by these Terms and the Mbogi Protocol governance rules.' },
    { id: 'equity', title: '2. Skill Equity & Tokenization', content: 'Labor contributed to projects is converted to equity based on the 1:1 Skill-Value peg. These assets are recorded on-chain and are subject to the specific smart contract logic of each project.' },
    { id: 'investments', title: '3. Investment Risks', content: 'Film financing carries inherent risks. MbogiCapital does not guarantee returns. Users should only contribute capital or labor they are prepared to risk.' },
    { id: 'conduct', title: '4. User Conduct', content: 'All "Proof of Work" submissions must be authentic. Manipulation of time logs or gear verification is grounds for immediate protocol exclusion.' }
  ];

  return (
    <div className="bg-white min-h-screen font-sans text-slate-900 pt-24 pb-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <Scale className="w-12 h-12 text-[#c07d3e] mx-auto mb-4" />
          <h1 className="text-4xl font-extrabold mb-4">Terms & Conditions</h1>
          <p className="text-slate-500">Last Updated: January 2026</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12">
          {/* Table of Contents */}
          <aside className="lg:w-1/4 hidden lg:block sticky top-32 h-fit">
            <nav className="space-y-4">
              {sections.map((s) => (
                <a key={s.id} href={`#${s.id}`} className="block text-sm font-medium text-slate-400 hover:text-[#c07d3e] transition-colors">
                  {s.title}
                </a>
              ))}
            </nav>
          </aside>

          {/* Content */}
          <div className="lg:w-3/4 space-y-12">
            {sections.map((s) => (
              <section key={s.id} id={s.id} className="scroll-mt-32">
                <h2 className="text-xl font-bold mb-4 text-[#0a1d2e]">{s.title}</h2>
                <p className="text-slate-600 leading-relaxed">{s.content}</p>
              </section>
            ))}
            
            <div className="bg-orange-50 p-6 rounded-2xl border border-orange-100 flex gap-4">
              <AlertCircle className="text-[#c07d3e] shrink-0" />
              <p className="text-xs text-[#c07d3e] font-medium leading-relaxed">
                Note: MbogiCapital operates on immutable smart contracts. Certain transactions once executed on the blockchain cannot be reversed.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}